export default{
        getUrlKey:function(name){
            return decodeURIComponent((new RegExp('[?|&]'+name+'='+'([^&;]+?)(&|#|;|$)').exec(location.href)||[,""])[1].replace(/\+/g,'%20'))||null;
     }
    }


//////////////////
// WEBPACK FOOTER
// ./static/js/geturlpara.js
// module id = 264
// module chunks = 1